import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { AppService } from 'src/app/app.service';
import { CaseBigPhotoComponent } from 'src/app/component/case-big-photo/case-big-photo.component';
import { Utility } from 'src/app/utility/Utility';
import {JsonCase, JsonTongue, ResourceUrlDto, TongueDiagnosisDto} from 'src/model/dto';
import { SeverityEnum, ToastMsg } from 'src/model/page';

@Component({
  selector: 'tudi-case-dialog',
  templateUrl: './case-dialog.component.html',
  styleUrls: ['./case-dialog.component.scss']
})
export class CaseDialogComponent {
  @ViewChild(CaseBigPhotoComponent) caseBigPhoto: CaseBigPhotoComponent;
  @Input() case: JsonCase;
  @Output() tagging: EventEmitter<JsonCase> = new EventEmitter();
  @Output() edit: EventEmitter<JsonCase> = new EventEmitter();
  @Output() delete: EventEmitter<number> = new EventEmitter();
  isShow = false;
  tongueTypes: SelectItem[] = [];
  diagnosisResults: TongueDiagnosisDto[];

  constructor(
    private appService: AppService,
    private msgService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.tongueTypes = [
      {label: 'Shape', value: 1},
      {label: 'Color', value: 2},
      {label: 'Coating', value: 3}
    ];
  }

  setShow(isShow: boolean): void {
    this.isShow = isShow;
  }

  openBigPhoto(): void {
    this.caseBigPhoto.show();
  }

  getTaggingStr(type: number, isAI: boolean): any[] {
    return this.case.tongues
      .filter(tongue => tongue.tongueType === type)
      .filter(tongue => isAI ? tongue.tagger.id === 0 : tongue.tagger.id > 0)
      .map(tongue => {
        return {
          str: Utility.toTongueStr(tongue),
          color: tongue.tagger.color ? tongue.tagger.color : (isAI ? '#808080' : 'orange'),
          taggerName: tongue.tagger.name
        };
      });
  }

  onEdit(): void {
    this.isShow = false;
    this.edit.emit(this.case);
  }

  onTagging(): void {
    this.isShow = false;
    this.tagging.emit(this.case);
  }

  onDelete(event: Event): void {
    console.log('onDelete');
    this.confirmationService.confirm({
      target: event.target,
      message: 'Are you sure to delete the case of ' + this.case.name + '?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.appService.setBlock(true);
        this.appService.post('data', 'deleteCase', {caseId: this.case.id}).subscribe({
          next: () => {
            this.appService.setBlock(false);
            this.delete.emit(this.case.id);
            this.msgService.add(new ToastMsg(SeverityEnum.success, 'Succeed to delete Case', ''));
            this.isShow = false;
          },
          error: err => {
            this.appService.setBlock(false);
          }
        });
      }
    });
  }

  diagnose(): void {
    this.appService.setBlock(true);
    const params = {
      caseId: this.case.id,
    };
    this.appService.post('data', 'diagnoseTongueFromCase', params).subscribe({
      next: (res: TongueDiagnosisDto[]) => {
        this.diagnosisResults = res;
        this.appService.setBlock(false);
      },
      error: err => {
        this.appService.setBlock(false);
      }
    });
  }

  closeDiagnosisDisplayer(event): void {
    this.diagnosisResults = null;
  }

  get TaggerStrs(): string[] {
    let result = [];
    if (this.case.createTagger) {
      result.push('The first tagger: ' + this.case.createTagger.name);
    }
    if (this.case.lastTagger) {
      result.push('The last tagger: ' + this.case.lastTagger.name);
    }
    return result;
  }
}
